import CONFIGURATION from "./env";

export type IdfPublicAuthConfig = {
  oauth_enabled: boolean;
  password_login_enabled: boolean;
  provider_name: string;
};

export type IdfAdminAuthSettings = {
  super_admin_user_id?: string;
  oauth_enabled: boolean;
  password_login_enabled: boolean;
  force_password_login: boolean;
  provider_name: string;
  issuer_url: string;
  client_id: string;
  client_secret_configured: boolean;
  authorization_url: string;
  token_url: string;
  userinfo_url: string;
  jwks_url: string;
  token_endpoint_auth_method: string;
  pkce_enabled: boolean;
  scopes: string[];
  allowed_emails: string[];
  allowed_email_domains: string[];
  require_email_verified: boolean;
  require_account_verified: boolean;
};

export type IdfAdminAuthSettingsUpdate = Omit<
  IdfAdminAuthSettings,
  "super_admin_user_id" | "force_password_login" | "client_secret_configured"
> & {
  client_secret?: string;
  clear_client_secret: boolean;
};

export type IdfSession = {
  _id: string;
  token: string;
  user_id: string;
};

export const IDF_AUTH_API_URL = `${CONFIGURATION.DEFAULT_API_URL.replace(
  /\/$/,
  "",
)}/auth/idf`;

async function readResponse<T>(response: Response): Promise<T> {
  if (response.ok) return response.json() as Promise<T>;

  const error = await response
    .json()
    .catch(() => ({ type: "OperationFailed" }));
  throw error;
}

export async function idfAuthRequest<T>(
  path: string,
  init?: RequestInit,
  authentication?: [string, string],
): Promise<T> {
  const headers = new Headers(init?.headers);
  headers.set("Accept", "application/json");
  if (init?.body) headers.set("Content-Type", "application/json");
  if (authentication) headers.set(authentication[0], authentication[1]);

  return readResponse<T>(
    await fetch(`${IDF_AUTH_API_URL}${path}`, {
      ...init,
      headers,
    }),
  );
}

export async function fetchIdfPublicAuthConfig(): Promise<IdfPublicAuthConfig> {
  return idfAuthRequest<IdfPublicAuthConfig>("/config");
}
